{
  "instagram_url": "https://www.instagram.com/grileinfo/",
  "instagram_name": "grileinfo",
  "facebook_url": "https://www.facebook.com/profile.php?id=61551697088326",
  "facebook_name": "Grile.info",
  "community_url": "",
  "grile_count": 10000,
  "pages_enabled": false,
  "particles_enabled": false,
  "light_mode_enabled": false,
  "guided_tour_enabled": false,
  "community_toast_enabled": false,
  "multiple_faculties_enabled": true,
  "ranking_enabled": false,
  "subject_cohort_enabled": false,
  "objective": "facultate",
  "objective_articulated": "facultatea",
  "objective_plural": "facultăți",
  "objective_plural_articulated": "facultățile",
  "exam_type": "admitere",
  "exam_type_articulated": "admiterea",
  "exam_type_plural": "admiteri",
  "exam_type_plural_articulated": "admiterile",
  "order_materii": ["Limba Română", "Economie", "Gândire critică"],
  "materie": "materie",
  "materii": "materii"
}
